import Button from '../../components/form-control/Button';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import {setStaffSupervisor} from '../../api/requests';
import SelectDropdown, {ISelectDropdownItem} from '../../components/form-control/SelectDropdown';
import Loader from '../../components/Loader';
import usePartner from '../../hooks/partnerHook';
import useUserAccount from '../../hooks/userAccountHook';
import { showToast } from '../../utils/miscFunctions';

const SetStaffSupervisor = ({
  onProceed,
  onClose,
  staffId
}: {
  onProceed: () => void;
  onClose: () => void;
  staffId: number;
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(true);
  const [admins, setAdmins] = useState<any>([]);
  const {getAllCompanyStaff} = usePartner();
  const { user } = useUserAccount();
  const teamId = user?.company?.id;

  useEffect(() => {
    getAllCompanyStaff(Number(teamId)).then((response)=>{
        setAdmins(response)
    }).catch((error)=>{
    }).finally(()=>{
      setLoadingData(false)
    })
  }, [])
  

  const submitHandler = (values: any) => {
    setSubmitting(true);

    setStaffSupervisor(staffId, values.id).then((response)=>{
      onClose();
      showToast.success(response?.message || 'Staff assigned to supervisor successfully');
    }).catch((error)=>{
        showToast.error(error?.description || 'Failed to assign staff to supervisor');
    }).finally(() => setSubmitting(false));

   
  };
  return (
    <div className="bg-white rounded-xl dark:bg-darkBg">
     
      {loadingData ? (
        <div className="py-10 flex items-center justify-center ">
          <Loader message={`Loading data . Please wait...`} brollyLoaderFixed size='sm'/>
        </div>
      ) : 
      (
      <>
       <div className="p-[1rem] flex items-start  mt-[26px]">
        <span className="text-darkBg-mainText">You are about to select a supervisor.</span>
      </div>
      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            id: ''
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({
            // email: Yup.string().email('Email provided invalid.').required('Email is requied.')
          })}
          onSubmit={(values) => {
            submitHandler(values);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <SelectDropdown
                    search={true}
                  label="Select Supervisor"
                  name="id"
                  list={admins?.map((admin: any) => ({
                    name: `${admin.fullName}`,
                    value: admin.id
                  }))}
                  listSelectedValue={values.id}
                  onChange={(val: ISelectDropdownItem | null) => {
                    setFieldValue('id', val);
                  }}
                  onBlur={handleBlur}
                  placeholder="Select Supervisor"
                  error={touched.id ? errors.id : undefined}
                  helperText={touched?.id ? errors.id : undefined}
                  required
                />
              </div>

               <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Submit"
                  bgColor='primary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
      
      </>)}
    </div>
  );
};

export default SetStaffSupervisor;
